import { render, staticRenderFns } from "./SectionSchedule.vue?vue&type=template&id=a159da52&scoped=true"
import script from "./SectionSchedule.vue?vue&type=script&lang=ts"
export * from "./SectionSchedule.vue?vue&type=script&lang=ts"
import style0 from "./SectionSchedule.vue?vue&type=style&index=0&id=a159da52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a159da52",
  null
  
)

export default component.exports